<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<div class="flex-layout-row flex-layout-align-start-center flex-layout-gap-10px">
	<button *ngIf="service.itemsCount" mat-icon-button (click)="exportList()">
		<mat-icon title="Export">cloud_download</mat-icon>
	</button>
</div>

<div class="paged-addlist-table-container">
	<table id="order-search-list" mat-table #table [dataSource]="service.itemList" matSort [matSortActive]="sortProperty" [matSortDirection]="sortDirection" matSortDisableClear *ngIf="service.itemsCount">
		<ng-container matColumnDef="hasRefundedTickets" sticky>
			<th mat-header-cell *matHeaderCellDef class="center">Refunded</th>
			<td mat-cell *matCellDef="let row" class="center">
				<mat-icon *ngIf="row.dataModel.hasRefundedTickets" style="color: #68f7f5" title="This order has refunded tickets">money_off</mat-icon>
			</td>
		</ng-container>
		<ng-container matColumnDef="orderNumber" sticky>
			<th mat-header-cell mat-sort-header *matHeaderCellDef>Order Number</th>
			<td mat-cell *matCellDef="let row">
				<a [routerLink]="['/orders', row.dataModel.id]">{{ row.dataModel.orderNumber }}</a>
			</td>
		</ng-container>
		<ng-container matColumnDef="orderDate">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>Order Date</th>
			<td mat-cell *matCellDef="let row">
				{{ row.dataModel.orderDate | date : 'dd/MM/yyyy' }}
			</td>
		</ng-container>

		<ng-container matColumnDef="entryCount">
			<th mat-header-cell *matHeaderCellDef class="right">Entry (Count)</th>
			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.entryCount }}
			</td>
		</ng-container>
		<ng-container matColumnDef="nonEntryCount">
			<th mat-header-cell *matHeaderCellDef class="right">Non Entry (Count)</th>
			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.nonEntryCount }}
			</td>
		</ng-container>
		<ng-container matColumnDef="glampingCount">
			<th mat-header-cell *matHeaderCellDef class="right">Glamping (Count)</th>
			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.glampingCount }}
			</td>
		</ng-container>

		<ng-container matColumnDef="entryDetails">
			<th mat-header-cell *matHeaderCellDef>Entry (Details)</th>
			<td mat-cell *matCellDef="let row">
				<list-column-with-tooltip rowValue="{{ row.dataModel.entryDetails }}"></list-column-with-tooltip>
			</td>
		</ng-container>
		<ng-container matColumnDef="nonEntryDetails">
			<th mat-header-cell *matHeaderCellDef>Non Entry (Details)</th>
			<td mat-cell *matCellDef="let row">
				<list-column-with-tooltip rowValue="{{ row.dataModel.nonEntryDetails }}"></list-column-with-tooltip>
			</td>
		</ng-container>
		<ng-container matColumnDef="glampingDetails">
			<th mat-header-cell *matHeaderCellDef>Glamping (Details)</th>
			<td mat-cell *matCellDef="let row">
				<list-column-with-tooltip rowValue="{{ row.dataModel.glampingDetails }}"></list-column-with-tooltip>
			</td>
		</ng-container>

		<ng-container matColumnDef="customer">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>Customer</th>
			<td mat-cell *matCellDef="let row">
				<list-column-with-tooltip rowValue="{{ row.dataModel.customer }}"></list-column-with-tooltip>
			</td>
		</ng-container>
		<ng-container matColumnDef="paymentPlan">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>Payment Plan</th>
			<td mat-cell *matCellDef="let row">
				{{ row.dataModel.paymentPlan }}
				<!-- <a [routerLink]="['/enter-route-here', row.dataModel.id]">{{ row.dataModel.paymentPlan }}</a> -->
			</td>
		</ng-container>
		<ng-container matColumnDef="paymentMethod">
			<th mat-header-cell *matHeaderCellDef>Payment Method</th>
			<td mat-cell *matCellDef="let row">
				<list-column-with-tooltip rowValue="{{ row.dataModel.paymentMethod }}"></list-column-with-tooltip>
			</td>
		</ng-container>
		<ng-container matColumnDef="event">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>Event</th>
			<td mat-cell *matCellDef="let row">
				<list-column-with-tooltip rowValue="{{ row.dataModel.event }}" [canAccessLink]="true" [route]="['/events', row.dataModel.eventId]"></list-column-with-tooltip>
			</td>
		</ng-container>
		<ng-container matColumnDef="eventDate">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>Event Date</th>
			<td mat-cell *matCellDef="let row" start="desc">
				{{ row.dataModel.eventDate | date : 'dd/MM/yyyy' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="tickets">
			<th mat-header-cell *matHeaderCellDef>Tickets</th>
			<td mat-cell *matCellDef="let row">
				<list-column-with-tooltip rowValue="{{ row.dataModel.tickets }}"></list-column-with-tooltip>
			</td>
		</ng-container>
		<ng-container matColumnDef="organiser">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>Organiser</th>
			<td mat-cell *matCellDef="let row">
				<list-column-with-tooltip rowValue="{{ row.dataModel.organiser }}"></list-column-with-tooltip>
			</td>
		</ng-container>
		<ng-container matColumnDef="venue">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>Venue</th>
			<td mat-cell *matCellDef="let row">
				<list-column-with-tooltip rowValue="{{ row.dataModel.venue }}"></list-column-with-tooltip>
			</td>
		</ng-container>
		<ng-container matColumnDef="eventStatus">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>Event Status</th>
			<td mat-cell *matCellDef="let row">
				{{ row.dataModel.eventStatus }}
			</td>
		</ng-container>
		<ng-container matColumnDef="genre">
			<th mat-header-cell *matHeaderCellDef>Genre</th>
			<td mat-cell *matCellDef="let row">
				<list-column-with-tooltip rowValue="{{ row.dataModel.genre }}"></list-column-with-tooltip>
			</td>
		</ng-container>
		<ng-container matColumnDef="faceValueTotal">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Face Value Total"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.faceValueTotal | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="bookingFee">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Booking Fee"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.bookingFee | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="venueLevyFee">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Venue Levy Fee"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.venueLevyFee | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="discount">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Discount"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.discount | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="processingFee">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Processing Fee"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.processingFee | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="dispatchMethodFee">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Dispatch Method Fee"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.dispatchMethodFee | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="cancellationProtectionFee">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Cancellation Protection Fee"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.cancellationProtectionFee | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="charityDonationAmount">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Charity Donation Amount"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.charityDonationAmount | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="orderTotal">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Order Total"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.orderTotal | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="orbitProcessingFee">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Orbit Processing Fee"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.orbitProcessingFee | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="orbitCancellationProtectionFee">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Orbit Cancellation Protection Fee"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.orbitCancellationProtectionFee | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="orbitServiceFee">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Orbit Service Fee"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.orbitServiceFee | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="orbitDispatchMethodFee">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Orbit Dispatch Method Fee"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.orbitDispatchMethodFee | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="orbitReceives">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Orbit Receives"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.orbitReceives | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="venueReceives">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Venue Receives"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.venueReceives | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="organiserProcessingFee">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Organiser Processing Fee"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.organiserProcessingFee | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="organiserTicketIncome">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Organiser Ticket Income"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.organiserTicketIncome | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="organiserReceives">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Organiser Receives"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.organiserReceives | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="partnerCancellationProtectionFee">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Partner Cancellation Protection Fee"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.partnerCancellationProtectionFee | number : '1.2-2' }}
			</td>
		</ng-container>
		<ng-container matColumnDef="charityReceives">
			<th mat-header-cell *matHeaderCellDef arrowPosition="before" class="right">
				<column-header-with-currency title="Charity Receives"></column-header-with-currency>
			</th>

			<td mat-cell *matCellDef="let row" class="right">
				{{ row.dataModel.charityReceives | number : '1.2-2' }}
			</td>
		</ng-container>

		<ng-container matColumnDef="discountCode">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>Discount Code</th>
			<td mat-cell *matCellDef="let row">
				<list-column-with-tooltip rowValue="{{ row.dataModel.discountCode }}"></list-column-with-tooltip>
			</td>
		</ng-container>
		<ng-container matColumnDef="membershipCode">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>Membership Code</th>
			<td mat-cell *matCellDef="let row">
				<list-column-with-tooltip rowValue="{{ row.dataModel.membershipCode }}"></list-column-with-tooltip>
			</td>
		</ng-container>

		<ng-container matColumnDef="actions" stickyEnd>
			<th mat-header-cell *matHeaderCellDef class="right"></th>
			<td mat-cell *matCellDef="let row" class="right">
				<icon-action-button-list [data]="row.itemId" class="action-icons" [actionItems]="row.processActions" (onInvokeAction)="doIconButtonAction($event)"></icon-action-button-list>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="selectRow(row)" [ngClass]="{ 'table-row-selected': row.dataModel.id == selectedRowId }"></tr>
	</table>
	<no-results *ngIf="!service.itemsCount"></no-results>
</div>
<div>
	<mat-paginator [length]="service.itemsCount" [pageIndex]="service.paginatorIndex" [pageSize]="service.listRequest.pageSize" showFirstLastButtons="true" *ngIf="service.itemsCount"></mat-paginator>
</div>
